import { ListeTable } from '@mairistem/liste';
import type { ReactNode } from 'react';

import type { PayeurType } from '@/types';

import PayeurListeTableRow from './PayeurListeTableRow';

interface PayeurListeTableProps {
  items: Array<PayeurType>;
  count: number;
  mode?: string;
  perPage: number;
  loading: boolean;
  onLoad: any;
  onSelect: any;
  onSort: any;
}

const PayeurListeTable = (props: PayeurListeTableProps) => {
  const { items, mode, count, perPage, loading, onLoad, onSort, onSelect } = props;

  const renderRow = (item, invalidate) => (
    <PayeurListeTableRow item={item} mode={mode} invalidate={invalidate} />
  );

  return (
    <ListeTable
      items={items}
      loading={loading}
      count={count}
      showCount
      countLabel={count > 1 ? 'payeurs' : 'payeur'}
      perPage={perPage}
      onLoad={onLoad}
      onSort={onSort}
      onSelect={onSelect}
    >
      <ListeTable.Header>
        <ListeTable.Column name="nom" width={5} sortable>
          Nom du payeur
        </ListeTable.Column>
        <ListeTable.Column name="adresse" width={11} sortable only={['m', 'l', 'xl']}>
          Adresse de facturation
        </ListeTable.Column>
      </ListeTable.Header>
      {renderRow as unknown as ReactNode}
    </ListeTable>
  );
};

export default PayeurListeTable;
